import { Component, OnInit, EventEmitter } from '@angular/core';
import { SessionService, TableColumns, TableConfiguration, MenuBreadCrumb } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { DisabilitiesDetailComponent } from './disabilities-detail/disabilities-detail.component';
import { Disabilities } from 'src/app/models/human-resources/disabilities';


@Component({
    selector: 'app-disabilities',
    templateUrl: './disabilities.component.html',
    styleUrls: ['./disabilities.component.scss'],
    standalone: false
})
export class DisabilitiesComponent implements OnInit {
  public urlGetIncapacidades: string = `${EndpointDictionary.Disabilities.DISABILITIES_TABLE}`;

  public titleIncapacidades: string = screen.width<500?'':'Incapacidades'

  public recargarTablaIncapacidades = new EventEmitter<any>()
  public configurationIncapacidades: TableConfiguration = {
    edit: false,
    add: true,
    delete: false,
    selectable: false,
    addPer: true,
    editPer: false,
    primaryKey: 'id',
    view: true

  }
  public columnasIncapacidades: TableColumns<Disabilities>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    },
    {
      ID: 'userName',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'disabilityType',
      label: 'Tipo Incapacidad',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'startDate',
      label: 'Fecha inicio',
      type: 'fecha',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'duration',
      label: 'Duración',
      type: 'string',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    }
  ]

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Incapacidades",
    current:true
  }]

  constructor(
    private session: SessionService,
    public dialog: MatDialog,
    public deleteItem: DeleteGenericService
  ) { }

  ngOnInit(): void {
  }

  agregarIncapacidades($event) {
    //console.log($event)
    this.session.setData('redireccion', 'nuevo')

    this.dialog.open(DisabilitiesDetailComponent, {
      width:'80%',
      data: ''

    }).afterClosed().subscribe(res=>{
      this.recargarTablaIncapacidades.emit()
    })
  }

  editarIncapacidades($event) {
    //console.log($event)
  }

  async eliminarIncapacidades($event) {
    //console.log($event)
    // let res =  await this.deleteItem.deleteD($event, this.urlDeleteIncapacidades, "id", "Icapacidad", "Incapacidades")
    //       this.recargarTablaIncapacidades.emit()
  }

  seleccionadosIncapacidades($event) {
    //console.log($event)
  }

  viewDisabilitie($event:Disabilities[]) {
    //console.log($event)
    this.session.setData('redireccion', 'visualizar')

    this.dialog.open(DisabilitiesDetailComponent, {
      width:'80%',
      data: $event[0]

    })
  }

}
